'use client';

import NumberToPrice from '@/_components/NumberToPrice';
import { ISingleOrder } from '@/_service/types/orders';
import { getStatus, getStatusName } from '@/_utils/getStatus';
import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useTranslations } from 'next-intl';
import { getColor } from '../../utils/get-color-status';

type Props = {
  order: ISingleOrder;
  total: number;
};

const OrderInfo: React.FC<Props> = ({ order, total }) => {
  const t = useTranslations();

  return (
    <HStack justifyContent={'space-between'}>
      <VStack align='start' gap={0}>
        <Text fontSize={20} fontWeight={600}>
          {t('order')} №{order.external_order_id}
        </Text>
        <HStack gap={2} fontWeight={500} alignItems={'center'}>
          <Text fontSize='sm' color='gray.600'>
            {order.created_at && dayjs(order.created_at).format('D MMMM HH:mm')}
          </Text>
        </HStack>
      </VStack>

      <Box textAlign='end'>
        <NumberToPrice
          textProps={{
            fontWeight: 600,
            fontSize: 20,
          }}
          spanProps={{
            fontWeight: 600,
            fontSize: 20,
          }}
          value={total + (+order?.service_fee || 0)}
        />
        {(order?.discount_price !== 0 ||
          order?.steps?.[0]?.step_discount_price !== 0) && (
          <NumberToPrice
            parentProps={{ justifyContent: 'flex-end' }}
            textProps={{
              fontSize: 'sm',
              color: 'text.muted',
              fontWeight: 500,
              textDecoration: 'line-through',
            }}
            value={
              total -
              order?.discount_price -
              (order?.steps?.[0]?.step_discount_price || 0) +
              (+order?.service_fee || 0)
            }
          />
        )}

        <Text
          textAlign='end'
          fontSize={{ base: '13px', lg: '15px' }}
          lineHeight='22px'
          fontWeight='medium'
          color={order.status_id ? getColor(getStatus(order.status_id)) : ''}
          display={{ lg: 'none' }}
        >
          {order?.delivery_type === 'hall' && order?.pos_id
            ? t(`order_list.vendor-accepted`)
            : order?.status_id
              ? t(`order_list.${getStatusName(order?.status_id)}`)
              : ''}
        </Text>
      </Box>
    </HStack>
  );
};

export default OrderInfo;
